// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';

// utilities
import _ from 'lodash';

// components
import Search from './r_Search';
import Filters from './Filters';
import ApplicantsColumn from './c_ApplicantsColumn';
import ApplicantsTable from './c_ApplicantsTable';
import { lookup } from '../../../redux/helpers/staticData';
import prettyTimezone from '../../../lib/prettyTimezone';

const tableGroups = ['Qualified', 'Inactive', 'No Longer Placeable'];


@connect(state => {
  // storing final object
  const applicantGroups = {};

  const qualifyingSpecialists = state.staticData.qualifyingSpecialists;

  // groups with keys as group names
  const statusGroups = _.keyBy(state.staticData.statusGroups, 'name');

  // statuses with keys as status names
  const applicantStatusKeyedByName = _.keyBy(state.staticData.applicantStatus, 'name');

  // add empty 'applicants' array to statuses
  _.forEach(applicantStatusKeyedByName, applicantStatus => applicantStatus.applicants = []); // eslint-disable-line no-return-assign

  // push corresponding applicants into the 'applicants' arrays
  _.forEach(_.omit(state.admin.applicants.search, ['pinned']), (group, groupName) => {
    if (!~tableGroups.indexOf(groupName) && !_.isEmpty(group.items)) {
      group.items.forEach(applicant => {
        const statusName = applicant.profile.applicantStatus.name;
        applicantStatusKeyedByName[statusName].applicants.push(_.merge(
          _.pick(applicantStatusKeyedByName[statusName], ['color', 'label', 'lifespan']),
          applicant,
          {
            timezone: prettyTimezone(lookup(state.staticData, 'timezoneList', {id: applicant.user.timezone})),
            bestContactTime: lookup(state.staticData, 'bestContactTimeList', {id: applicant.user.bestContactTime}),
          }
        ));
      });
    }
    else {
      _.set(applicantGroups, `${groupName}.data`, _.get(state.admin.applicants.search, groupName));
    }
  });
  // organizing into nested object
  _(applicantStatusKeyedByName)
    .groupBy('subGroup')
    .forEach((subGroup, subGroupName) => {
      _.forEach(statusGroups, (group, groupName) => {
        // check if subGroup status is contained in group
        if(~group.statuses.indexOf(subGroup[0].id)) {
          // if so, use lodash's deep property set method to place this object on 'applicantGroups'
          _.set(applicantGroups, `${groupName}.${subGroupName}`, _(subGroup).keyBy('name').mapValues(val => val.applicants).value());
        }
      });
    });

  const searchQuery = state.routing.locationBeforeTransitions.query.search;

  return {
    user: state.user,
    qualifyingSpecialists,
    applicants: state.admin.applicants.search,
    applicantGroups,
    applicantStatusKeyedByName,
    search: searchQuery && [].concat(searchQuery) || [],
    staticData: state.staticData,
  };
})
export default class ApplicantManager extends Component {
  static propTypes = {
    user: PropTypes.object,
    qualifyingSpecialists: PropTypes.any,
    dispatch: PropTypes.func.isRequired,
    expandCard: PropTypes.func.isRequired,
    navColumnState: PropTypes.string.isRequired,
    applicants: PropTypes.any,
    applicantGroups: PropTypes.object,
    applicantStatusKeyedByName: PropTypes.object,
    selectedEmail: PropTypes.string,
    search: PropTypes.array,
    onSearch: PropTypes.func,
    onPageChange: PropTypes.func,
    staticData: PropTypes.object,
  }

  state = {
    filters: {},
    terms: [],
    currentPage: 0,
    pageSize: 25,
  }

  onTermChange(terms) {
    this.setState({ terms, currentPage: 0 }, () => this.props.onSearch(this.state.terms, this.state.filters));
  }

  onFilterChange(filters) {
    this.setState({ filters, currentPage: 0 }, () => this.props.onSearch(this.state.terms, this.state.filters));
  }

  OnPageChange(group, currentPage, pageSize, sortBy) {
    this.setState({
      currentPage,
    });
    this.props.onPageChange(this.state.terms, this.state.filters, group, pageSize * currentPage, sortBy);
  }

  render() {
    return (
      <ul className='applicant-manager columns-container'>
        {
          <div className='admin-top-bar'>
            <Search navColumnState={this.props.navColumnState} onTermChange={::this.onTermChange}/>
            <Filters
              terms={this.state.terms}
              onFilterChange={::this.onFilterChange}
              staticData={this.props.staticData}
              specialists={this.props.qualifyingSpecialists}
              admin={!!~this.props.user.roles.indexOf('Admin')}
              navColumnState={this.props.navColumnState}
            />
          </div>
        }
        {
          (!~tableGroups.indexOf(this.props.navColumnState) && this.props.applicantGroups[this.props.navColumnState])
            &&
          _.map(_.omit(this.props.applicantGroups[this.props.navColumnState], ['data']), (column, header) =>
            <ApplicantsColumn
              key={this.props.navColumnState}
              terms={this.state.terms}
              key={header}
              expandCard={this.props.expandCard}
              selectedEmail={this.props.selectedEmail}
              header={header}
              applicantsColumn={column}
              applicantStatusKeyedByName={this.props.applicantStatusKeyedByName}/>
          )
        }
        {
          (!!~tableGroups.indexOf(this.props.navColumnState) && this.props.applicantGroups[this.props.navColumnState])
            &&
          <ApplicantsTable
            key={this.props.navColumnState}
            terms={this.state.terms}
            expandCard={this.props.expandCard}
            selectedEmail={this.props.selectedEmail}
            applicantGroup={this.props.applicantGroups[this.props.navColumnState]}
            navColumnState={this.props.navColumnState}
            total={_.get(this.props.applicants, `${this.props.navColumnState}.total`, 0)}
            qualifyingSpecialists={this.props.qualifyingSpecialists}
            applicantStatusKeyedByName={this.props.applicantStatusKeyedByName}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            OnPageChange={::this.OnPageChange}
          />
        }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_AdminDashboard/r_ApplicantManager/index.js